import 'objectFitPolyfill'

export default () => {
    const buttons = document.querySelectorAll('.js-play-fullscreen-video')
    const fullscreens = document.querySelectorAll('.js-fullscreen-video')
    const closeButtons = document.querySelectorAll('.js-close-fullscreen-video')
    const { body } = document
    const videos = document.querySelectorAll('.js-video')
    ;[...videos].forEach(container => {
        // Loop heros & test for autoplay
        const video = container.querySelector('video')
        const overlay = container.querySelector('.js-video-overlay')
        video.addEventListener('play', () => {
            // Test if autoplay is working, if it is hide background/overlary
            overlay.classList.add('c-vacancy__background--hidden')
        })
    })
    if (buttons.length) {
        ;[].forEach.call(buttons, button => {
            button.addEventListener('click', function () {
                const parent = document.getElementById(this.dataset.target)
                const video = parent.querySelector('video')
                parent.classList.add('c-fullscreen-video--active')

                // // scroll to top
                // window.scrollTo(0, 0)

                body.classList.add('fullscreen-video-playing')

                // play video
                video.play()
            })
        })
    }
    if (closeButtons.length) {
        ;[].forEach.call(closeButtons, button => {
            button.addEventListener('click', () => {
                closeAll()
            })
        })
    }

    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) closeAll()
    })
    if (fullscreens.length) {
        ;[].forEach.call(fullscreens, fullscreen => {
            const fullscreenVideo = fullscreen.querySelector('video')
            fullscreenVideo.addEventListener(
                'ended',
                e => {
                    closeAll()
                },
                false,
            )
        })
    }

    const closeAll = () => {
        ;[].forEach.call(fullscreens, fullscreen => {
            const video = fullscreen.querySelector('video')
            body.classList.remove('fullscreen-video-playing')
            fullscreen.classList.remove('c-fullscreen-video--active')
            video.pause()
            video.currentTime = 0
        })
    }
}

// WEBPACK FOOTER //
// ./src/js/modules/Video.js
